<aside
  class="flex flex-col w-full h-full bg-transparent transition-colors duration-300 text-slate-300">

  <!-- ══════════ ย่อเมนู: แถบไอคอน ══════════ -->
  <ng-container *ngIf="isCollapsed(); else expandedNav">
    <div class="flex-none flex flex-col items-center gap-1 pt-3 pb-2 border-b border-[#2d2d30]">
      <div
        class="logo-badge w-10 h-10 rounded-xl bg-[#facc15] text-[#1f1f20] flex items-center justify-center font-bold text-xl shadow-lg shadow-[#facc15]/30 select-none mb-1">
        C
      </div>
      <button type="button" (click)="toggleSidebarLock()" title="ขยายเมนู"
        class="w-10 h-8 rounded-lg text-slate-400 hover:text-[#facc15] hover:bg-[#2d2d30] flex items-center justify-center transition">
        <span class="material-icons text-[20px]">keyboard_double_arrow_right</span>
      </button>
      <button type="button" (click)="openPalette()" title="ค้นหาเมนู (Ctrl K)"
        class="w-10 h-10 rounded-lg text-slate-400 hover:text-[#facc15] hover:bg-[#2d2d30] flex items-center justify-center transition">
        <span class="material-icons text-[20px]">search</span>
      </button>
    </div>

    <div class="flex-1 overflow-y-auto scrollbar-hide flex flex-col items-center gap-1 py-2">
      <ng-container *ngIf="isMenuLoading()">
        <div *ngFor="let i of [1, 2, 3, 4, 5]" class="w-10 h-10 rounded-lg bg-[#2d2d30] animate-pulse"></div>
      </ng-container>

      <ng-container *ngIf="!isMenuLoading()">
        <ng-container *ngFor="let group of menuGroups; let gi = index">
          <div *ngIf="gi > 0" class="w-8 h-px bg-[#2d2d30] my-1"></div>
          <ng-container *ngFor="let item of group.children">
            <button *ngIf="item.submenu; else railLink" type="button" (click)="expandToItem(item)"
              [title]="item.name"
              class="relative w-10 h-10 rounded-lg flex items-center justify-center transition hover:bg-[#2d2d30]"
              [ngClass]="isParentActive(item) ? 'text-[#facc15] bg-[#2d2d30]' : 'text-slate-400 hover:text-[#facc15]'">
              <span class="material-icons-outlined text-[20px]">{{ item.icon }}</span>
            </button>
            <ng-template #railLink>
              <a [routerLink]="item.url" [title]="item.name" (click)="onMenuNavigate(item.url)"
                routerLinkActive="!text-[#facc15] bg-[#2d2d30]"
                [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
                class="relative w-10 h-10 rounded-lg flex items-center justify-center transition text-slate-400 hover:text-[#facc15] hover:bg-[#2d2d30]">
                <span class="material-icons-outlined text-[20px]">{{ item.icon }}</span>
                <ng-container *ngIf="isParkingLiveRoute(item.url)">
                  <span *ngIf="(parkingExitCount$ | async) as count"
                    class="absolute top-0.5 right-0.5 min-w-[14px] h-[14px] px-[3px] flex items-center justify-center rounded-full bg-rose-500 text-white text-[8px] font-bold">{{ count }}</span>
                </ng-container>
                <ng-container *ngIf="isEvChargerLiveRoute(item.url)">
                  <span *ngIf="(evExitCount$ | async) as count"
                    class="absolute top-0.5 right-0.5 min-w-[14px] h-[14px] px-[3px] flex items-center justify-center rounded-full bg-rose-500 text-white text-[8px] font-bold">{{ count }}</span>
                </ng-container>
              </a>
            </ng-template>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>

  <!-- ══════════ ขยายเมนู ══════════ -->
  <ng-template #expandedNav>

    <!-- ── Brand Header ── -->
    <div class="sidebar-logo flex-none h-16 px-4 flex items-center gap-3 border-b border-[#2d2d30]">
      <div
        class="logo-badge w-10 h-10 shrink-0 rounded-xl bg-[#facc15] text-[#1f1f20] flex items-center justify-center font-bold text-xl shadow-lg shadow-[#facc15]/30 select-none">
        C
      </div>
      <div class="flex-1 min-w-0 flex items-center h-8">
        <img src="img/logo.png" alt="logo"
          class="h-8 max-w-[120px] object-contain filter drop-shadow-[0_2px_8px_rgba(251,191,36,0.2)]" />
      </div>
      <button *ngIf="variant === 'desktop'" type="button" (click)="toggleSidebarLock()" title="ย่อเมนู"
        class="w-8 h-8 shrink-0 rounded-lg text-slate-500 hover:text-[#facc15] hover:bg-[#2d2d30] flex items-center justify-center transition">
        <span class="material-icons text-[20px]">keyboard_double_arrow_left</span>
      </button>
      <button *ngIf="variant === 'drawer'" type="button" (click)="closeRequested.emit()" title="ปิดเมนู"
        class="w-9 h-9 shrink-0 rounded-full text-slate-400 hover:text-[#facc15] hover:bg-[#2d2d30] flex items-center justify-center transition">
        <span class="material-icons text-[20px]">close</span>
      </button>
    </div>

    <!-- ── Site Selector Dropdown ── -->
    <div class="flex justify-center w-full px-3 mt-3 site-selector-container relative z-[50]"
      *ngIf="siteState.sites().length > 0">
      <div class="relative w-full">
        <button id="site-selector-btn" type="button" (click)="toggleSiteDropdown()" (blur)="closeSiteDropdown()"
          [disabled]="isMenuLoading()"
          class="w-full flex items-center gap-2 px-3 py-2 rounded-full text-[11px] font-semibold transition-all duration-200
                 border bg-[#facc15] hover:bg-[#ebd213] text-[#1f1f20] border-[#facc15]
                 shadow-md shadow-[#facc15]/30 disabled:opacity-50 disabled:cursor-not-allowed">
          <span class="material-icons text-[15px] leading-none shrink-0">place</span>
          <span class="nav-label flex-1 truncate text-left site-selector-label"
            (mouseenter)="showNavTooltip($event, siteState.selectedSite()?.name || 'เลือกสาขา')"
            (mouseleave)="hideNavTooltip()">
            {{ siteState.selectedSite()?.name || 'เลือกสาขา' }}
          </span>
          <span
            class="material-icons text-xs leading-none transition-transform duration-200 shrink-0 site-selector-chevron"
            [class.rotate-180]="showSiteDropdown">
            expand_more
          </span>
        </button>

        <div *ngIf="showSiteDropdown" (mousedown)="preventBlur($event)"
          class="absolute left-0 right-0 top-full mt-2 rounded-2xl shadow-2xl overflow-hidden z-50 animate-fade-in-up
                 bg-[#252526]/95 border border-[#3a3a3d]/50 backdrop-blur-sm">

          <div class="p-3 border-b border-[#2d2d30]" *ngIf="siteState.sites().length > 4">
            <div class="flex items-center gap-2 px-3 py-1.5 rounded-xl bg-[#1f1f20]">
              <span class="material-icons text-base text-slate-400">search</span>
              <input id="site-search-input" type="text" [(ngModel)]="siteSearchText" placeholder="ค้นหาสาขา..."
                class="flex-1 bg-transparent text-xs outline-none text-slate-200 placeholder:text-slate-500" />
            </div>
          </div>

          <div class="custom-scrollbar overflow-y-auto max-h-60">
            <button type="button" *ngFor="let site of filteredSites" (click)="onSiteSelect(site)"
              class="w-full flex items-center gap-3 px-4 py-2.5 text-xs transition-all duration-150 text-left
                     text-slate-300 hover:bg-[#2d2d30] hover:text-[#facc15]">

              <span class="flex-shrink-0 w-2 h-2 rounded-full transition-all duration-200"
                [class.bg-[#facc15]]="siteState.selectedSite()?.id === site.id"
                [class.bg-slate-600]="siteState.selectedSite()?.id !== site.id">
              </span>

              <span class="flex-1 truncate" [class.font-semibold]="siteState.selectedSite()?.id === site.id">
                {{ site.name }}
              </span>

              <span class="material-icons text-base text-[#facc15] transition-opacity duration-200"
                [class.opacity-100]="siteState.selectedSite()?.id === site.id"
                [class.opacity-0]="siteState.selectedSite()?.id !== site.id">
                check_circle
              </span>
            </button>

            <div *ngIf="filteredSites.length === 0" class="px-4 py-6 text-center text-xs text-slate-400">
              <span class="material-icons text-2xl block mb-1">search_off</span>
              ไม่พบสาขา
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ── Menu Search ── -->
    <div class="flex-none px-3 pt-3">
      <div class="flex items-center gap-2 bg-[#1f1f20] rounded-xl px-3 py-2 border border-transparent focus-within:border-[#facc15]/40">
        <span class="material-icons text-[18px] text-slate-500">search</span>
        <input id="sidebar-menu-search" type="text" [value]="searchQuery()" (input)="onSearchInput($event)"
          (keydown.escape)="clearSearch()" placeholder="ค้นหาเมนู..." autocomplete="off"
          class="flex-1 min-w-0 bg-transparent outline-none text-base md:text-[12.5px] text-slate-200 placeholder:text-slate-500" />
        <button *ngIf="isSearching()" type="button" (click)="clearSearch()" title="ล้างคำค้น"
          class="w-5 h-5 rounded-full flex items-center justify-center text-slate-500 hover:text-slate-200">
          <span class="material-icons text-[15px]">close</span>
        </button>
        <kbd *ngIf="!isSearching() && variant === 'desktop'"
          class="text-[10px] text-slate-500 border border-white/10 rounded px-1 font-sans">Ctrl K</kbd>
      </div>
    </div>

    <!-- ── Drag Hint Popup ── -->
    <div *ngIf="showDragHint && variant === 'desktop'" class="mx-3 mt-3 animate-fade-in-down">
      <div
        class="relative flex items-start gap-2.5 px-3 py-2.5 bg-amber-900/20 border border-amber-700/40 rounded-xl shadow-sm">
        <div class="shrink-0 w-7 h-7 rounded-lg bg-amber-500/20 flex items-center justify-center">
          <span class="material-icons-outlined text-amber-400" style="font-size:16px">open_in_new</span>
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-[10px] font-bold text-amber-400 leading-none mb-0.5">เคล็ดลับ</p>
          <p class="text-[10px] text-amber-300/80 leading-snug">
            กดค้างแล้วลากเมนูไปยังแท็บข้างบน เพื่อ<strong>เปิดแท็บใหม่</strong>
          </p>
        </div>
        <button (click)="dismissDragHint()"
          class="shrink-0 w-5 h-5 flex items-center justify-center text-amber-400 hover:text-amber-300 transition-colors rounded-md hover:bg-amber-800/30">
          <span class="material-icons-outlined" style="font-size:14px">close</span>
        </button>
      </div>
    </div>

    <!-- ── Navigation ── -->
    <div class="flex-1 overflow-y-auto px-2 pb-4 custom-scrollbar nav-container" (scroll)="hideNavTooltip()">

      <div *ngIf="isMenuLoading()" class="space-y-2 py-3 px-1">
        <div *ngFor="let i of [1, 2, 3, 4, 5, 6]"
          class="flex items-center gap-2.5 px-3 py-2 pointer-events-none select-none">
          <div class="w-5 h-5 bg-[#2d2d30] rounded-md animate-pulse shrink-0"></div>
          <div class="h-3 flex-1 bg-[#252526] rounded-md animate-pulse"></div>
        </div>
      </div>

      <!-- ผลค้นหา: รายการเดียว พร้อมที่อยู่ของเมนู -->
      <ng-container *ngIf="!isMenuLoading() && isSearching()">
        <ng-container *ngIf="searchResults().length; else noResult">
          <div class="px-3 mt-3 mb-1 text-[11px] text-slate-500">พบ {{ searchResults().length }} หน้า</div>
          <a *ngFor="let leaf of searchResults()" [routerLink]="leaf.url" (click)="onMenuNavigate(leaf.url)"
            routerLinkActive="active-search-result"
            class="search-result group flex items-start gap-2.5 px-3 py-2 rounded-lg text-slate-300 hover:bg-[#2d2d30] hover:text-[#facc15] transition">
            <span class="material-icons-outlined text-[17px] text-slate-500 group-hover:text-[#facc15] mt-px">{{ leaf.icon }}</span>
            <span class="flex-1 min-w-0">
              <span class="block text-[12.5px] truncate">
                <ng-container *ngFor="let part of highlight(leaf.name)">
                  <mark *ngIf="part.hit; else plain" class="bg-[#facc15] text-[#1f1f20] rounded-sm px-px">{{ part.text }}</mark>
                  <ng-template #plain>{{ part.text }}</ng-template>
                </ng-container>
              </span>
              <span class="block text-[10.5px] text-slate-500 truncate">
                {{ leaf.heading }}<ng-container *ngIf="leaf.parentName"> › {{ leaf.parentName }}</ng-container>
              </span>
            </span>
            <span *ngIf="leaf.live"
              class="inline-flex items-center gap-1 text-[9px] px-1.5 py-0.5 rounded-full bg-[#facc15]/10 text-[#facc15] font-bold border border-[#facc15]/20 mt-0.5">
              <span class="w-1.5 h-1.5 rounded-full bg-[#facc15] animate-pulse"></span>LIVE
            </span>
          </a>
        </ng-container>
        <ng-template #noResult>
          <div class="py-10 flex flex-col items-center justify-center text-slate-500 text-center px-3">
            <span class="material-icons-outlined text-4xl mb-2 opacity-50">search_off</span>
            <p class="text-xs">ไม่พบเมนูที่ตรงกับ "{{ searchQuery().trim() }}"</p>
          </div>
        </ng-template>
      </ng-container>

      <ng-container *ngIf="!isMenuLoading() && !isSearching()">

        <div *ngIf="menuGroups.length === 0"
          class="py-10 flex flex-col items-center justify-center text-slate-500">
          <span class="material-icons-outlined text-4xl mb-2 opacity-50">menu_open</span>
          <p class="text-xs">ไม่มีเมนูที่เข้าถึงได้</p>
        </div>

        <!-- Favorites -->
        <ng-container *ngIf="favoriteList().length > 0">
          <div class="section-heading">ชื่นชอบ</div>
          <ul class="space-y-0.5">
            <li *ngFor="let fav of favoriteList()">
              <a [routerLink]="fav.url"
                routerLinkActive="bg-[#facc15]/10 active-favorite-text font-semibold"
                class="fav-menu-item group relative flex items-center gap-2.5 px-3 py-1.5 rounded-lg text-[12px]
                       text-slate-300 hover:text-[#facc15] hover:bg-[#2d2d30] transition cursor-grab active:cursor-grabbing"
                (click)="onMenuNavigate(fav.url)">
                <span class="material-icons-outlined text-[16px] text-slate-500 group-hover:text-[#facc15]">{{ fav.icon }}</span>
                <span class="nav-label flex-1 min-w-0 truncate"
                  (mouseenter)="showNavTooltip($event, fav.name)" (mouseleave)="hideNavTooltip()">{{ fav.name }}</span>

                <span *ngIf="fav.live"
                  class="inline-flex items-center gap-1 text-[9px] px-1.5 py-0.5 rounded-full bg-[#facc15]/10 text-[#facc15] font-bold tracking-wide border border-[#facc15]/20">
                  <span class="w-1.5 h-1.5 rounded-full bg-[#facc15] animate-pulse"></span>
                  LIVE
                </span>

                <ng-container *ngIf="isParkingLiveRoute(fav.url)">
                  <span *ngIf="(parkingExitCount$ | async) as count"
                    class="min-w-[16px] h-[16px] px-[3px] flex items-center justify-center rounded-full bg-rose-500 text-white text-[8px] font-bold shadow-md shadow-rose-500/40 animate-bounce">
                    {{ count }}
                  </span>
                </ng-container>
                <ng-container *ngIf="isEvChargerLiveRoute(fav.url)">
                  <span *ngIf="(evExitCount$ | async) as count"
                    class="min-w-[16px] h-[16px] px-[3px] flex items-center justify-center rounded-full bg-rose-500 text-white text-[8px] font-bold shadow-md shadow-rose-500/40 animate-bounce">
                    {{ count }}
                  </span>
                </ng-container>

                <button (click)="toggleFavorite(fav, $event)" title="นำออกจากที่ชื่นชอบ"
                  class="flex items-center justify-center focus:outline-none shrink-0 w-5 hover:scale-125 active:scale-90 text-[#facc15]">
                  <span class="material-icons" style="font-size: 16px">star</span>
                </button>
              </a>
            </li>
          </ul>
        </ng-container>

        <!-- Recently opened -->
        <ng-container *ngIf="nav.recentLeaves().length > 0">
          <div class="section-heading">เปิดล่าสุด</div>
          <div class="flex flex-wrap gap-1.5 px-3">
            <a *ngFor="let leaf of nav.recentLeaves()" [routerLink]="leaf.url" (click)="onMenuNavigate(leaf.url)"
              routerLinkActive="!bg-[#facc15] !text-[#1f1f20] font-semibold"
              [title]="leaf.heading + (leaf.parentName ? ' › ' + leaf.parentName : '')"
              class="max-w-full truncate px-2.5 py-1 rounded-full text-[11px] bg-white/5 text-slate-300 hover:text-[#facc15] transition">
              {{ leaf.name }}
            </a>
          </div>
        </ng-container>

        <div *ngIf="favoriteList().length > 0 || nav.recentLeaves().length > 0"
          class="h-px bg-[#2d2d30] mx-3 mt-4 mb-1"></div>

        <!-- Menu groups -->
        <ng-container *ngFor="let group of menuGroups">
          <div class="section-heading flex items-center gap-2">
            {{ group.heading }}
            <span *ngIf="group.heading == 'อื่นๆ'"
              class="flex items-center gap-1 px-2 py-0.5 rounded-full bg-[#facc15]/10 text-[#facc15] font-bold border border-[#facc15]/20 text-[9px] normal-case">
              <span class="material-icons-outlined" style="font-size: 12px;">info</span>
              กำลังปรับปรุงระบบ
            </span>
          </div>

          <ul class="space-y-0.5">
            <li *ngFor="let item of group.children" (dragenter)="onListDragEnter($event, item)"
              (dragleave)="onListDragLeave($event, item)" (dragover)="onListDragOver($event, item)">

              <ng-container *ngIf="item.submenu; else singleLink">

                <button type="button" (click)="toggleSubmenu(item)"
                  class="parent-btn group w-full flex items-center gap-3 px-3 py-2 rounded-lg text-[12.5px] font-medium select-none transition"
                  [ngClass]="item.expanded ? 'text-white bg-white/5' : 'text-slate-300 hover:bg-[#2d2d30]'">
                  <span class="menu-icon material-icons-outlined text-[19px] transition-colors"
                    [ngClass]="isParentActive(item) ? 'text-[#facc15]' : 'text-slate-500 group-hover:text-[#facc15]'">
                    {{ item.icon }}
                  </span>
                  <span class="nav-label flex-1 min-w-0 truncate text-left"
                    (mouseenter)="showNavTooltip($event, item.name)" (mouseleave)="hideNavTooltip()">{{ item.name }}</span>
                  <span class="text-[10.5px] text-slate-500 shrink-0">{{ item.submenu.length }}</span>
                  <span class="material-icons text-[18px] text-slate-500 transition-transform duration-200 shrink-0"
                    [class.rotate-180]="item.expanded">expand_more</span>
                </button>

                <div *ngIf="item.expanded" class="submenu-wrapper ml-5 pl-2 border-l border-white/10 mb-1.5 mt-0.5">
                  <a *ngFor="let subItem of item.submenu" [routerLink]="subItem.url"
                    routerLinkActive="active active-btn-submenu" (dragover)="onDragOver($event, subItem)"
                    (dragleave)="onDragLeave($event, subItem)" (drop)="onDrop($event, subItem)"
                    [class.ring-2]="isDraggingOverUrl === subItem.url"
                    [class.ring-[#facc15]]="isDraggingOverUrl === subItem.url"
                    class="relative submenu-link group flex items-center gap-2 px-3 py-1.5 rounded-lg text-[12px]
                           text-slate-400 hover:text-[#facc15] hover:bg-[#2d2d30] transition cursor-grab active:cursor-grabbing"
                    (click)="onMenuNavigate(subItem.url)">

                    <span class="nav-label submenu-label flex-1 min-w-0 truncate"
                      (mouseenter)="showNavTooltip($event, subItem.name)"
                      (mouseleave)="hideNavTooltip()">{{ subItem.name }}</span>

                    <span *ngIf="subItem.live"
                      class="inline-flex items-center gap-1 text-[9px] px-1.5 py-0.5 rounded-full bg-[#facc15]/10 text-[#facc15] font-bold tracking-wide border border-[#facc15]/20">
                      <span class="w-1.5 h-1.5 rounded-full bg-[#facc15] animate-pulse"></span>
                      LIVE
                    </span>

                    <ng-container *ngIf="isParkingLiveRoute(subItem.url)">
                      <span *ngIf="(parkingExitCount$ | async) as count"
                        class="min-w-[16px] h-[16px] px-[3px] flex items-center justify-center rounded-full bg-rose-500 text-white text-[8px] font-bold shadow-md shadow-rose-500/40 animate-bounce">
                        {{ count }}
                      </span>
                    </ng-container>

                    <ng-container *ngIf="isEvChargerLiveRoute(subItem.url)">
                      <span *ngIf="(evExitCount$ | async) as count"
                        class="min-w-[16px] h-[16px] px-[3px] flex items-center justify-center rounded-full bg-rose-500 text-white text-[8px] font-bold shadow-md shadow-rose-500/40 animate-bounce">
                        {{ count }}
                      </span>
                    </ng-container>

                    <span *ngIf="subItem.badge"
                      class="text-[9px] px-1.5 py-0.5 rounded-full bg-amber-400 text-slate-950 font-bold tracking-wide shadow-sm">
                      {{ subItem.badge.text }}
                    </span>

                    <button (click)="toggleFavorite(subItem, $event)"
                      [title]="isFavorite(subItem.id) ? 'นำออกจากที่ชื่นชอบ' : 'เพิ่มในที่ชื่นชอบ'"
                      class="favorite-btn flex items-center justify-center focus:outline-none shrink-0 w-5 transition hover:scale-125 active:scale-90"
                      [class.is-favorite]="isFavorite(subItem.id)"
                      [class.text-[#facc15]]="isFavorite(subItem.id)" [class.text-slate-500]="!isFavorite(subItem.id)">
                      <span class="material-icons" style="font-size: 16px;">{{ isFavorite(subItem.id) ? 'star' : 'star_border' }}</span>
                    </button>
                  </a>
                </div>

              </ng-container>

              <ng-template #singleLink>
                <a [routerLink]="item.url"
                  routerLinkActive="active-menu"
                  [routerLinkActiveOptions]="{ exact: item.exact ?? false }" (click)="onMenuNavigate(item.url)"
                  class="menu-item group relative flex items-center gap-3 px-3 py-2 rounded-lg text-[12.5px] font-medium
                         text-slate-300 hover:bg-[#2d2d30] hover:text-[#facc15] transition cursor-grab active:cursor-grabbing">

                  <span class="menu-icon material-icons-outlined text-[19px] text-slate-500 group-hover:text-[#facc15] transition-colors">
                    {{ item.icon }}
                  </span>

                  <span class="nav-label flex-1 min-w-0 truncate"
                    (mouseenter)="showNavTooltip($event, item.name)" (mouseleave)="hideNavTooltip()">{{ item.name }}</span>

                  <span *ngIf="item.live"
                    class="inline-flex items-center gap-1 text-[9px] px-1.5 py-0.5 rounded-full bg-[#facc15]/10 text-[#facc15] font-bold tracking-wide border border-[#facc15]/20">
                    <span class="w-1.5 h-1.5 rounded-full bg-[#facc15] animate-pulse"></span>
                    LIVE
                  </span>

                  <ng-container *ngIf="isParkingLiveRoute(item.url)">
                    <span *ngIf="(parkingExitCount$ | async) as count"
                      class="min-w-[16px] h-[16px] px-[3px] flex items-center justify-center rounded-full bg-rose-500 text-white text-[8px] font-bold shadow-md shadow-rose-500/40 animate-bounce">
                      {{ count }}
                    </span>
                  </ng-container>
                  <ng-container *ngIf="isEvChargerLiveRoute(item.url)">
                    <span *ngIf="(evExitCount$ | async) as count"
                      class="min-w-[16px] h-[16px] px-[3px] flex items-center justify-center rounded-full bg-rose-500 text-white text-[8px] font-bold shadow-md shadow-rose-500/40 animate-bounce">
                      {{ count }}
                    </span>
                  </ng-container>

                  <span *ngIf="item.badge"
                    class="text-[9px] px-1.5 py-0.5 rounded-full bg-[#facc15] text-slate-950 font-bold tracking-wide shadow-md shadow-black/20">
                    {{ item.badge.text }}
                  </span>

                  <button (click)="toggleFavorite(item, $event)"
                    [title]="isFavorite(item.id) ? 'นำออกจากที่ชื่นชอบ' : 'เพิ่มในที่ชื่นชอบ'"
                    class="favorite-btn flex items-center justify-center focus:outline-none shrink-0 w-5 transition hover:scale-125 active:scale-90"
                    [class.is-favorite]="isFavorite(item.id)"
                    [class.text-[#facc15]]="isFavorite(item.id)" [class.text-slate-500]="!isFavorite(item.id)">
                    <span class="material-icons text-[16px]">{{ isFavorite(item.id) ? 'star' : 'star_border' }}</span>
                  </button>
                </a>
              </ng-template>

            </li>
          </ul>
        </ng-container>
      </ng-container>

      <div class="h-4"></div>
    </div>

    <div class="sidebar-footer flex-none border-t border-[#2d2d30] px-4 py-2.5 text-[10px] text-slate-500 text-center">
      v{{ appVersion || '—' }} &bull; City Parking Admin
    </div>
  </ng-template>

</aside>
